module.exports = __webpack_public_path__ + "images/favs-beta-logo-centered.png";